<template>
  <v-container wrap>
    <h1>{{ $t('message.select_academy') }}</h1>
    <v-select
      dense
      outlined
      :items="items"
      item-text="text"
      item-value="value"
      v-model="defaultSelected"
    ></v-select>
    <h1 v-if="!loading && items.length == 0" style="color:red">{{ $t('message.no_academies') }}</h1>
    <v-footer color="none" app inset>
      <v-btn icon small @click="logout()" v-if="$store.state.isUserLoggedIn">
        <LogoutIcon class="hero-button"></LogoutIcon>
      </v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import Api from "@/services/Api";

import { 
  LogoutIcon,
} from '@vue-hero-icons/outline'

export default {
  data() {
    return {
      loading: false,
      selectedItem: null,
      items: [],
      defaultSelected: null
    };
  },
  components: {
    LogoutIcon
  },
  created() {
    //If only one, continue
    this.getAdminAcademies();
  },
  watch: {
    defaultSelected: {
      handler: function(newValue) {
        if(this.$store.state.selectedAcademy != newValue){
          this.processAcademy(newValue);
        }
      }
    }
  },
  methods: {
    processAcademy(id){
      this.defaultSelected = id;
      this.$store.dispatch("setSelectedAcademy", id);
      this.$store.dispatch("setStripeAccountId", null);
      for(const i of this.items){
        if(i.value == id){
          this.$store.dispatch("setManagedAcademy", i.id);
          this.$store.dispatch("setAcademyImage", i.image);
          break;
        }
      }
      //Go to Checkin page
      this.navigateTo({name: 'checkin'});
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      localStorage.removeItem("token");
      window.location.replace('/login?specialroute=checkin');
    },
    getAdminAcademies(){
      this.loading = true;
      //AdminService.academies();
      Api().get('admins/academies')
        .then(response => {
          var array = [];
          const data = response.data;
          if(data && data.length > 0){
            if(data.length == 1){
              this.$store.state.selectedAcademy = data[0].academy._id;
              this.navigateTo({name: 'checkin'});
            }else{
              for(const a of data){
                if(a.default)
                  this.defaultAcademy = a.academy._id;
                array.push({text:a.academy.name,value:a.academy._id, image:a.academy.image})
              }
              this.items = array;
              if(!this.$store.state.selectedAcademy){
                //Update          
                this.$store.dispatch("setSelectedAcademy", this.defaultAcademy);
                this.defaultSelected = this.defaultAcademy;
              }else{
                this.defaultSelected = this.$store.state.selectedAcademy;
              }
            }
          }
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>